import React, { useEffect } from "react";
import Sider from "antd/lib/layout/Sider";
import { ArrowIco, CollapseIco, WrapIco } from "../../assets/customIcons";
import { Collapse, Select, Row, InputNumber, Tag, Button } from "antd";
import RegistryApi from "../../api/Registry";
import DefectRegister from "../../store/defectRegister";
import { observer } from "mobx-react";
import { runInAction, toJS } from "mobx";
import { DatePickerComponentAnalytics } from "../../modules/SitPanel/components/Analytics/DatePickerComponentAnalytics";
import "./index.scss";

const { Panel } = Collapse;
const { Option } = Select;

export const AnalyticsFilter = observer(({ onCloseAnalytics, store }) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const [organizations, setOrganizations] = React.useState([]);
  useEffect(() => {
    // NsiApi.getGridTypes().then((response) => {
    //   setGridTypes(response.data.items);
    // });
    RegistryApi.getOrganizations().then((response) => {
      setOrganizations(response.data);
    });
  }, []);
  const collapseClick = (e) => {
    e.stopPropagation();
    onCloseAnalytics();
  };
  const onDateChange = (e) => {
    // store.setDate(e[0], e[1]);
    store.DateFrom = e && e[0]?.toDate();
    store.DateTo = e && e[1]?.toDate();
  };
  const collapseButton = (
    <CollapseIco title={"Выйти из аналитики"} onClick={collapseClick} />
  );

  // const orgArr = organizations.filter(
  //   (org, idx) => org.id == toJS(store.organizationIds)[idx],
  // );
  const orgArr = React.useRef([]);
  const ArrOrg = [];
  for (let i = 0; i < store.organizationIds.slice().length; i++) {
    ArrOrg.push(
      ...organizations.filter(
        (org, idx) => org.id == toJS(store.organizationIds)[i],
      ),
    );
  }
  orgArr.current = ArrOrg;
  const gridTypes = [
    { id: 1, title: "Теплоснабжение" },
    { id: 2, title: "Водоснабжение" },
    { id: 5, title: "Водоотведение" },
    { id: 6, title: "Электроснабжение" },
    { id: 3, title: "Газоснабжение" },
    { id: 4, title: "Освещение" },
  ];
  const gridTypesArr = React.useRef([]);
  const Arr = [];
  for (let i = 0; i < store.gridTypeIds.slice().length; i++) {
    Arr.push(
      ...gridTypes.filter((t, idx) => t.id == store.gridTypeIds.slice()[i]),
    );
  }
  gridTypesArr.current = Arr;
  return (
    <>
      <Sider
        width={361}
        collapsedWidth={20}
        className={"sider-filter"}
        collapsed={collapsed}
        trigger={null}
      >
        <WrapIco
          className={
            !collapsed ? "sider-filter__icon" : "sider-filter__icon rotate"
          }
          onClick={() => {
            DefectRegister.siderCollapsed = !DefectRegister.siderCollapsed;
            setCollapsed(!collapsed);
          }}
        />
        {!collapsed && (
          <Collapse
            expandIconPosition="right"
            bordered={false}
            defaultActiveKey={["1", "2"]}
            expandIcon={({ isActive }) => (
              <ArrowIco className={isActive ? "rotate" : null} />
            )}
            className="site-collapse-custom-collapse"
          >
            <DatePickerComponentAnalytics
              store={store}
              onChange={onDateChange}
            />
            <Panel
              header="Фильтры"
              key="1"
              className="site-collapse-custom-panel"
              // extra={collapseButton} выход из Аналитики
            >
              <div className="filter">
                <Row className={"tags"}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <p className="label-filter">Текущая выборка</p>
                    <Button
                      onClick={() => {
                        RegistryApi.getOrganizations().then((response) => {
                          setOrganizations(response.data);
                        });
                        runInAction(() => {
                          store.clearFilter();
                          store.getDefectsByGridTypes();
                          store.getEventsByStatus();
                          store.getEventsByOrganization();
                        });
                      }}
                      style={{ color: "#56B4A4" }}
                      type="link"
                    >
                      Сбросить
                    </Button>
                  </div>
                  {/*<Select*/}
                  {/*  className="custom-input"*/}
                  {/*  style={{ width: "100%" }}*/}
                  {/*  allowClear*/}
                  {/*  value={children}*/}
                  {/*  mode="multiple"*/}
                  {/*  onChange={handleChange}*/}
                  {/*>*/}
                  {/*  {children}*/}
                  {/*</Select>*/}
                  {gridTypesArr.current.map((t, idx) => {
                    return (
                      <Tag
                        onClose={() =>
                          runInAction(() => {
                            store.gridTypeIds = store.gridTypeIds.filter(
                              (id) => id != t.id,
                            );
                          })
                        }
                        key={idx}
                        closable
                      >
                        {t.title}
                      </Tag>
                    );
                  })}
                  {toJS(store.Eliminated) === null && null}
                  {toJS(store.Eliminated) === true && (
                    <Tag
                      onClose={() =>
                        runInAction(() => {
                          store.Eliminated = null;
                        })
                      }
                      closable
                    >
                      Устраненные
                    </Tag>
                  )}
                  {toJS(store.Eliminated) === false && (
                    <Tag
                      onClose={() =>
                        runInAction(() => {
                          store.Eliminated = store.Eliminated = null;
                        })
                      }
                      closable
                    >
                      Не устраненные
                    </Tag>
                  )}
                  {orgArr.current.map((org, idx) => {
                    return (
                      <Tag
                        onClose={() =>
                          runInAction(() => {
                            store.organizationIds =
                              store.organizationIds.filter(
                                (id) => id != org.id,
                              );
                          })
                        }
                        closable
                        key={idx}
                      >
                        {org.name}
                      </Tag>
                    );
                  })}
                  <hr style={{ marginBottom: "16px" }} />
                </Row>
                <Row>
                  <Select
                    onChange={(e) => {
                      RegistryApi.getOrganizations(e).then((response) => {
                        setOrganizations(response.data);
                      });
                      runInAction(() => {
                        store.setGridType(e);
                        store.getDefectsByGridTypes();
                        store.getEventsByOrganization();
                        store.getEventsByStatus();
                      });
                    }}
                    className="custom-input"
                    style={{ width: "100%" }}
                    allowClear={false}
                    placeholder="Тип сети"
                    value={store.gridTypeIds}
                  >
                    {gridTypes.map((gt, idx) => {
                      return (
                        <Option key={idx} value={gt.id}>
                          {gt.title}
                        </Option>
                      );
                    })}
                  </Select>
                </Row>
                <Row>
                  <Select
                    className="custom-input"
                    style={{ width: "100%" }}
                    allowClear={false}
                    placeholder="Готовность"
                    value={
                      store.Eliminated !== null
                        ? store.Eliminated
                          ? "1"
                          : "0"
                        : null
                    }
                    onChange={(e) => {
                      store.setElim(e == "1");
                    }}
                  >
                    <Option value="1">Устранено</Option>
                    <Option value="0">Не устранено</Option>
                  </Select>
                </Row>
                <Row>
                  <Select
                    className="custom-input"
                    style={{ width: "100%" }}
                    allowClear={false}
                    placeholder="Организация"
                    value={store.organizationIds}
                    onChange={(e) => {
                      runInAction(() => {
                        store.setOrgs(e);
                        store.getDefectsByGridTypes();
                        store.getEventsByOrganization();
                        store.getEventsByStatus();
                      });
                    }}
                  >
                    {organizations.map((o, idx) => {
                      return (
                        <Option key={idx} value={o.id}>
                          {o.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Row>
                <Row>
                  <p className="label-filter">Всего зданий</p>
                </Row>
                <Row className="filter-input-group">
                  <InputNumber
                    value={store.OverBuildingsFrom}
                    onChange={(e) => store.setOverBuildFrom(e)}
                    min="1"
                    precision={0}
                    placeholder="От"
                  />
                  <InputNumber
                    value={store.OverBuildingsTo}
                    precision={0}
                    onChange={(e) => store.setOverBuildTo(e)}
                    min="1"
                    placeholder="До"
                  />
                </Row>
                <Row>
                  <p className="label-filter">Жилых зданий</p>
                </Row>
                <Row className="filter-input-group">
                  <InputNumber
                    value={store.LivingBuildingsFrom}
                    precision={0}
                    onChange={(e) => store.setLivingBuildFrom(e)}
                    min="1"
                    placeholder="От"
                  />
                  <InputNumber
                    value={store.LivingBuildingsTo}
                    precision={0}
                    onChange={(e) => store.setLivingBuildTo(e)}
                    min="1"
                    placeholder="До"
                  />
                </Row>
                <Row>
                  <p className="label-filter">Лечебных зданий</p>
                </Row>
                <Row className="filter-input-group">
                  <InputNumber
                    value={store.HospitalBuildingsFrom}
                    precision={0}
                    onChange={(e) => store.setHospitalFrom(e)}
                    min="1"
                    placeholder="От"
                  />
                  <InputNumber
                    value={store.HospitalBuildingsTo}
                    precision={0}
                    onChange={(e) => store.setHospitalTo(e)}
                    min="1"
                    placeholder="До"
                  />
                </Row>
                <Row>
                  <p className="label-filter">Детских зданий</p>
                </Row>
                <Row className="filter-input-group">
                  <InputNumber
                    precision={0}
                    value={store.ChildrenBuildingsFrom}
                    onChange={(e) => store.setChildrenBuildFrom(e)}
                    min="1"
                    placeholder="От"
                  />
                  <InputNumber
                    value={store.ChildrenBuildingsTo}
                    precision={0}
                    onChange={(e) => store.setChildrenBuildTo(e)}
                    min="1"
                    placeholder="До"
                  />
                </Row>
                <Row>
                  <p className="label-filter">Количество абонентов</p>
                </Row>
                <Row className="filter-input-group">
                  <InputNumber
                    precision={0}
                    value={store.DisconnectedFrom}
                    onChange={(e) => store.setDisconnectFrom(e)}
                    min="1"
                    placeholder="От"
                  />
                  <InputNumber
                    value={store.DisconnectedTo}
                    precision={0}
                    onChange={(e) => store.setDisconnectTo(e)}
                    min="1"
                    placeholder="До"
                  />
                </Row>
              </div>
            </Panel>
          </Collapse>
        )}
      </Sider>
    </>
  );
});
